import { render, staticRenderFns } from "./motivosdesolicitud.vue?vue&type=template&id=4d6c07f0"
import script from "./motivosdesolicitud.vue?vue&type=script&lang=js"
export * from "./motivosdesolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports